export var AddInvestorAccountsOrFundsMode;
(function (AddInvestorAccountsOrFundsMode) {
    AddInvestorAccountsOrFundsMode[AddInvestorAccountsOrFundsMode["Default"] = 0] = "Default";
    AddInvestorAccountsOrFundsMode[AddInvestorAccountsOrFundsMode["AddFunds"] = 1] = "AddFunds";
    AddInvestorAccountsOrFundsMode[AddInvestorAccountsOrFundsMode["AddInvestorAccounts"] = 2] = "AddInvestorAccounts";
})(AddInvestorAccountsOrFundsMode || (AddInvestorAccountsOrFundsMode = {}));
